module.exports = __webpack_public_path__ + "img/Vector.41479e13.svg";